module.exports = __webpack_public_path__ + "img/ltr_completed_600.4989bda7.png";